import React from 'react';
import propTypes from 'prop-types';
export const RulesHandIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <g id="surface1">
        <path
          stroke="none"
          fillRule="nonzero"
          fill={color}
          fillOpacity="1"
          d="M 23.554688 15.003906 C 23.0625 14.558594 22.296875 14.585938 21.78125 15.003906 L 17.929688 18.085938 C 17.460938 18.460938 16.871094 18.664062 16.261719 18.664062 L 11.335938 18.664062 C 10.96875 18.664062 10.664062 18.367188 10.664062 18 C 10.664062 17.632812 10.96875 17.335938 11.335938 17.335938 L 14.59375 17.335938 C 15.257812 17.335938 15.875 16.878906 15.984375 16.226562 C 16.121094 15.390625 15.476562 14.664062 14.664062 14.664062 L 8 14.664062 C 6.875 14.664062 5.789062 15.054688 4.914062 15.761719 L 2.976562 17.335938 L 0.664062 17.335938 C 0.300781 17.335938 0 17.632812 0 18 L 0 22 C 0 22.367188 0.300781 22.664062 0.664062 22.664062 L 15.53125 22.664062 C 16.136719 22.664062 16.726562 22.460938 17.199219 22.085938 L 23.5 17.039062 C 24.132812 16.539062 24.183594 15.570312 23.554688 15.003906 Z M 23.554688 15.003906 "
        />
      </g>
    </svg>
  );
};
RulesHandIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
RulesHandIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
